/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagedModelProductAdminResponse } from '../../models/paged-model-product-admin-response';

export interface GetProductsForAdminByMerchantNameAsHal$Params {
  merchantId: string;
  brand?: string;
  name?: string;
  status?: 'PUBLISHED' | 'DRAFT' | 'REJECTED' | 'ONGOING';

/**
 * Zero-based page index (0..N)
 */
  page?: number;

/**
 * The size of the page to be returned
 */
  size?: number;

/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
  sort?: Array<string>;
}

export function getProductsForAdminByMerchantNameAsHal(http: HttpClient, rootUrl: string, params: GetProductsForAdminByMerchantNameAsHal$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelProductAdminResponse>> {
  const rb = new RequestBuilder(rootUrl, getProductsForAdminByMerchantNameAsHal.PATH, 'get');
  if (params) {
    rb.path('merchantId', params.merchantId, {});
    rb.query('brand', params.brand, {});
    rb.query('name', params.name, {});
    rb.query('status', params.status, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedModelProductAdminResponse>;
    })
  );
}

getProductsForAdminByMerchantNameAsHal.PATH = '/merchants/{merchantId}/products';
